import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import PropertyBookModal from './PropertyBookModal';
import { Link } from 'react-router-dom';
// icon
import Icon from '@mdi/react';
import { mdiMapMarkerRadiusOutline, mdiBedKingOutline, mdiShower, mdiArrowRightThin, mdiShieldLockOutline, mdiWifi, mdiCarSide, mdiHeartOutline, mdiHeart, mdiPool, mdiDumbbell, mdiFlower, mdiMovieOpenOutline, mdiGarage, mdiWashingMachine } from '@mdi/js';
// data
import PopularDealsData from "./property-data.json";
export default function PopularDeals() {
    const [PopularDealsList] = useState(PopularDealsData);

    // Popup
    const [showProperty, setShowProperty] = useState(false);
    const handleCloseProperty = () => setShowProperty(false);
    const handleShowProperty = () => setShowProperty(true);

    // icon fill
    const [likedDeals, setLikedDeals] = useState(
        PopularDealsList.PopularDeals.map(() => false)
    );
    const handleIconClick = (index) => {
        const updatedLikes = likedDeals.map((liked, i) => (i === index ? !liked : liked));
        setLikedDeals(updatedLikes);
    };

    // property icon 
    const getIconPath = (iconName) => {
        switch (iconName) {
            case 'mdiWashingMachine':
                return mdiWashingMachine;
            case 'mdiGarage':
                return mdiGarage;
            case 'mdiMovieOpenOutline':
                return mdiMovieOpenOutline;
            case 'mdiFlower':
                return mdiFlower;
            case 'mdiDumbbell':
                return mdiDumbbell;
            case 'mdiPool':
                return mdiPool;
            case 'mdiBedKingOutline':
                return mdiBedKingOutline;
            case 'mdiShower':
                return mdiShower;
            case 'mdiShieldLockOutline':
                return mdiShieldLockOutline;
            case 'mdiWifi':
                return mdiWifi;
            case 'mdiCarSide':
                return mdiCarSide;
            default:
                return mdiShower;
        }
    };

    return (
        <>
            <div>
                <section className='section section-light' id='property'>
                    <Container>
                        <Row>
                            <Col md={12}>
                                <div className='section-title-box'>
                                    <h1 className='section-title'><span className='text-primary'>Popular</span> Property Deals</h1>
                                </div>
                            </Col>
                        </Row>


                        <Row className='justify-content-center'>
                            {PopularDealsList.PopularDeals.map((data, i) =>
                                <Col md={6} xl={4} xxl={6} key={i} className='mb-4'>
                                    <Card className='proporty-deals-card overflow-hidden mb-0 h-100 rounded-3'>
                                        <Card.Body className='p-3'>
                                            <Row className='align-items-center'>
                                                <Col xxl={6}>
                                                    <div className='proporty-deals-img'>
                                                        <span className={`sale-badge ${data.badgeDisplay}`}>For Sale</span>
                                                        <img src={require(`../../images/property-img/${data.propertyImg}`)} alt='' className='img-fluid proporty-img rounded-3' />
                                                    </div>
                                                </Col>
                                                <Col xxl={6}>
                                                    <div className="d-flex align-items-center justify-content-between mb-2 mt-4 mt-xxl-0">
                                                        <h4 className='text-primary fw-semibold mb-0'>{data.propertyPrice}/ <span className='fs-14'>Night</span></h4>
                                                        <Link to='' className='text-danger float-end heart-icon' onClick={() => handleIconClick(i)}>
                                                            <Icon
                                                                path={likedDeals[i] ? mdiHeart : mdiHeartOutline}
                                                                className='icon-size-20 text-danger'
                                                            />
                                                        </Link>
                                                    </div>
                                                    <Card.Title className=''>{data.propertyTitle}</Card.Title>
                                                    <div className='d-flex align-items-center text-muted fs-15'>
                                                        <Icon path={mdiMapMarkerRadiusOutline} className='icon-size-18 me-2' />{data.homeLocation}
                                                    </div>
                                                    <div className='d-flex flex-wrap align-items-center gap-2 mt-2 mb-3'>
                                                        {data.propertyFeatures.map((feature, j) => (
                                                            <Badge bg="light" className='text-dark fs-13 d-flex align-items-center' key={j}>
                                                                <Icon path={getIconPath(feature.icon)} className='icon-size-16 me-2' />
                                                                {feature.value}
                                                            </Badge>
                                                        ))}
                                                    </div>
                                                    <Button variant="soft-primary" size='sm' onClick={handleShowProperty}>View More</Button>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                        <Row className='mt-5'>
                            <Col md={12} className='text-center'>
                                <Link className="btn btn-primary" to="/PropertyList">View More <Icon path={mdiArrowRightThin} className='icon-size-20 ms-1' /></Link>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <PropertyBookModal
                    showProperty={showProperty}
                    handleCloseProperty={handleCloseProperty}
                />
            </div>
        </>
    )
}
